import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: Service worker disabled to prevent stale cache issues (C-4 interim fix)
// Full versioned SW + forced update will be implemented in a future CR
serviceWorkerRegistration.unregister();
reportWebVitals();
